import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { addTestimonial, approveStatusChangeTestimonial, fetchTestimonialById, fetchTestimonialsTable, removeTestimonial, updateTestimonial } from "../../api/testimonialsApi";
import { IGetApiResponse, IGetReqData, ITestimonialData, TestimonialState } from "../../types/testimonials";

// Async thunks for special offer operations

export const getTestimonials = createAsyncThunk<IGetApiResponse, IGetReqData>("testimonials/getTestimonials", async (data) => {
  try {
    let response = await fetchTestimonialsTable(data.page, data.limit);
    return response.data;
  } catch (error: any) {
    throw error;
  }
});

export const getTestimonialsById = createAsyncThunk("testimonials/getTestimonialsById", async (id: string) => {
  try {
    let response = await fetchTestimonialById(id);
    return response.data;
  } catch (error: any) {
    throw error;
  }
}
);

export const createTestimonial = createAsyncThunk<IGetApiResponse, ITestimonialData>("testimonials/createTestimonial", async (newTestimonial) => {
  try {
    let response = await addTestimonial(newTestimonial);
    return response.data;
  } catch (error: any) {
    throw error;
  }
}
);

export const editTestimonials = createAsyncThunk("testimonials/editTestimonials", async ({ id, updatedTestimonial }: { id: string; updatedTestimonial: ITestimonialData }) => {
  try {
    return await updateTestimonial(id, updatedTestimonial);
  } catch (error: any) {
    throw error;
  }
}
);

export const deleteTestimonials = createAsyncThunk("testimonials/deleteTestimonials", async (id: string) => {
  try {
    let response = await removeTestimonial(id);
    return response.data;
  } catch (error: any) {
    throw error;
  }
});

export const approveTestimonials = createAsyncThunk("testimonials/approveTestimonials", async (data:{id:string,status:boolean}) => {
  try {
    let response = await approveStatusChangeTestimonial(data.id,data.status);
    return data;
  } catch (error: any) {
    throw error;
  }
});



const testimonialsSlice = createSlice({
  name: "testimonials",
  initialState: {
    testimonialLoader: false,
    testimonials: [],
    status: false,
    msg: "",
    error: null,
  } as TestimonialState,
  reducers: {
    // resetStatus(state) {
    //   state.status = null;
    //   state.msg = "";
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTestimonials.pending, (state, action) => {
        state.testimonialLoader = true;
        state.status = false;
        state.error = action.payload;
      })
      .addCase(getTestimonials.fulfilled, (state, action: PayloadAction<IGetApiResponse>) => {
        state.testimonials = action.payload.data;
        state.testimonialLoader = false;
        state.status = true;
      })
      .addCase(getTestimonials.rejected, (state, action) => {
        state.error = action.payload as string;
        state.testimonialLoader = false;
        state.status = false;
      })
      .addCase(approveTestimonials.pending, (state, action) => {
        state.testimonialLoader = true;
        state.status = false;
      })
      .addCase(approveTestimonials.fulfilled, (state, action: PayloadAction<{ id: string; status: boolean }>) => {
        const { id, status } = action.payload;
        state.testimonials = state.testimonials.map((testimonial)=>{
            if(testimonial.slug === id){
              testimonial.is_approve = status;
            }
            return testimonial;
        })
        state.testimonialLoader = false;
        state.status = true;

      })

    // // Get special offer by ID
    // .addCase(getTestimonialsById.fulfilled, (state, action: PayloadAction<any>) => {
    //   state.status = true;
    //   state.testimonials = action.payload;
    // })
    // .addCase(getTestimonialsById.rejected, (state, action) => {
    //   state.status = false;
    //   state.error = action.payload as string;
    // })

    // // Create special offer
    // .addCase(createTestimonial.fulfilled, (state, action: PayloadAction<ITestimonialData>) => {
    //   if (Array.isArray(action.payload)) {
    //     state.testimonials.push(action.payload);
    //     state.status = true;
    //     state.msg = "Testimonial created successfully.";
    //   } else {
    //     console.log('Testimonial not an array');
    //   }
    // })

    // // Edit special offer
    // .addCase(editTestimonials.fulfilled, (state, action: PayloadAction<{ id: number, data: ITestimonialData }>) => {
    //   const { id, data } = action.payload;
    //   if (Array.isArray(state.testimonials)) {
    //     const index = state.testimonials.findIndex((testimonial) => testimonial.id === id);
    //     if (index !== -1) {
    //       state.testimonials[index] = data;
    //     }
    //     state.status = true;
    //     state.msg = "Testimonial updated successfully.";
    //   } else {
    //     console.log('testimonial not an array');
    //   }
    // })

    // // Delete testimonial
    // .addCase(deleteTestimonials.fulfilled, (state, action: PayloadAction<{ id: number }>) => {
    //   if (Array.isArray(state.testimonials)) {
    //     state.testimonials = state.testimonials.filter((testimonial) => testimonial.id !== action.payload.id);
    //     state.status = true;
    //     state.msg = "Testimonial deleted successfully.";
    //   } else {
    //     console.log('testimonial not an array');
    //   }
    // });
  },
});

// export const { resetStatus } = testimonialsSlice.actions;
export default testimonialsSlice.reducer;
